export default __webpack_public_path__ + "static/media/bcd.theme.f6dd27a0.less";